import {useLocation} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import Box from "@mui/material/Box";
import {
    Tooltip,
    Typography
} from "@mui/material";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {SETTINGS_TYPES} from "../../../data/SettingsType";
import UtilityServiceOrganizationPictures from "../../../API/common/UtilityServiceOrganizationPictures";
import {BigImage, NewsSettingsModal, SetPictureModal} from "./Picture";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import OrganizationMediaService from "../../../API/common/OrganizationMediaService";

const CompositionPictures = ({itemId, handleModalAlert, isModal, selectedStringId, setSelectedString,}) => {
    const pathname = useLocation().pathname
    const [data, setData] = useState([]);
    const [isFirst, setIsFirst] = useState(true)
    const [bigImage, setBigImage] = useState(null);
    const [modal, setModal] = useState(false);
    const [loading, setLoading] = useState(false)
    const [change, setChange] = useState(false)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: isModal ? 10 : 100,
        totalElements: 7,
        searchData: ""
    })

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}+${itemId}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}+${itemId}`]?.pageSize
        const searchQuery = pagesData[`${pathname}+${itemId}`]?.searchQuery

        return {searchQuery, pageSize}
    }

    useEffect(() => {
        if (isFirst) {
            const {searchQuery, pageSize} = getStartPageSize()
            setTableOptions((prev) => ({
                ...prev,
                searchData: searchQuery || tableOptions?.searchQuery,
                pageSize: pageSize || tableOptions?.pageSize
            }))
            setIsFirst(false)
        } else {
            UtilityServiceOrganizationPictures.get("ORGANIZATION_COMPOSITION_MEDIA", tableOptions.pageIndex, tableOptions.pageSize, tableOptions.searchData).then(function (response) {
                const data = response?.data.content.sort((a, b) => a.priority - b.priority);
                setData(data);
                setTableOptions((prev) => ({...prev, totalElements: response?.data.total}))
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }
    }, [change, tableOptions.searchData, tableOptions.pageIndex, tableOptions.pageSize]);

    const handleClose = () => {
        setModal(false)
    }

    const handleSubmit = (values, file, handleClose) => {
        setLoading(true)
        OrganizationMediaService.addPictures(values, file)
            .then(function (response) {
                handleClose()
                setChange(!change)
                handleModalAlert("Данные добавлены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            }).finally(() => setLoading(false))
    }
    const handleDelete = (row) => {
        UtilityServiceOrganizationPictures.delete(row.id)
            .then(function () {
                setChange(!change)
                handleModalAlert("Данные удалены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };

    const columns = useMemo(() => {
        const baseColumns = [
            {
                header: 'Наименование', accessorKey: 'name', minSize: 700,
                Cell: ({row, cell}) => {
                    return <Tooltip arrow placement="bottom"
                                    title={row.original.name}><Box
                        sx={{
                            display: "inline-block",
                            width: "900px",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}>{cell.getValue()}</Box>
                    </Tooltip>
                }
            },
            {
                header: 'Картинка', accessorKey: 'relativeUrlSmall', minSize: 100,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return <Box sx={{
                        margin: "4px",
                        height: '100px',
                        width: "170px",
                        borderRadius: "8px",
                        backgroundImage: `url(${value})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        cursor: "pointer"
                    }}
                                onClick={() => setBigImage(row.original.relativeUrl)}/>
                },
            },
        ]
        return baseColumns;

    }, [data]);

    const menuItem = [{type: "delete", text: "Удалить", handler: handleDelete}]

    return (<Box
        sx={{
            overflow: 'auto',
            maxWidth: '1200px',
        }}
    >

        {!isModal && <Box
            sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px"}}
        >
            <Typography sx={{
                fontSize: "24px",
                fontWeight: 700,
                lineHeight: 1
            }}>{SETTINGS_TYPES[itemId]}</Typography>
            <ButtonCreate
                text={"Добавить"}
                width={130}
                onClick={() => setModal(true)}
            /></Box>}
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            muiTableContainerProps={{
                sx: {
                    width: '1200px',
                    maxHeight: `calc(100vh - 420px)`
                }
            }}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": !isModal && {
                        padding: 0,
                        width: "50px",
                        height: "100px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    onClick: () => setSelectedString && setSelectedString(row.original),
                    sx: () => ({
                        height: '36px',
                        cursor: setSelectedString && "pointer",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        '&:nth-of-type(even)': {
                            backgroundColor: row.original.id === selectedStringId ? (theme) => theme.palette.primary.light : (theme) => theme.palette.primary.lightGrey,
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                backgroundColor: row.original.id === selectedStringId ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                            },
                        },
                        backgroundColor: row.original.id === selectedStringId ? (theme) => theme.palette.primary.light : "white",
                        "&:hover": {
                            backgroundColor: row.original.id === selectedStringId ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                        },
                        "&.MuiTableRow-root.Mui-selected": {
                            backgroundColor: (theme) => theme.palette.primary.light70,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.light50,
                            },
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={data}
            onGlobalFilterChange={value => tableOptionsHandle({...tableOptions, searchData: value})}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            manualPagination={true}
            state={{showGlobalFilter: true, pagination: tableOptions}}
            rowCount={tableOptions.totalElements}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return <MenuItem
                    key={el.type}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })}
            localization={MRT_Localization_RU}
            enableRowActions={!isModal}
            enableToolbarInternalActions={false}
        />
        <NewsSettingsModal
            title={"Добавить"}
            open={modal} onClose={handleClose}
            handleSubmit={handleSubmit}
            editingPictureSystemType={false}
            initValue={{name: "", pictureSystemType: "ORGANIZATION_COMPOSITION_MEDIA"}}
            loading={loading}
        />
        <BigImage bigImage={bigImage} setBigImage={setBigImage}></BigImage>
    </Box>);
}
export default CompositionPictures;